/*eslint-disable no-script-url*/
import React, { Component, Fragment } from 'react';
import * as Common from '../components/Common';
import { Actions } from '../components/Actions';

let experienceTypeMap = {
  'FULL_TIME': '종일 09:00 ~ 24:00',
  'A_TYPE': '오전 09:00 ~ 13:00',
  'B_TYPE': '오후 13:00 ~ 17:00',
  'C_TYPE': '야간 17:00 ~ 21:00',
  'D_TYPE': '심야 21:00 ~ 24:00'
}

var _timer = null;

class RequestForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      branchName: '',
      branch_id: 0,
      memberSex: '',
      testUsedate: '',
      experienceType: '',
      memberName: '',
      memberBirthday: '',
      memberType: '',
      memberPhone: '',
      isWait: false,
      isParentReservation: '',
      studyType: '',
      recogType: '',
      isPolicy: false,
      isPrivacy: false,
      isMarketingAgree: false,
      isVerifyPhone: false,
      isVerifyExpired: false,
      isKioskForCobosys: false,
      verifyNum: '',
      inputVerifyNum: '',
      verifyNumText: '',
      expireSec: 180,
      expireCount: 0,
      expireText: ''
    }
  }

  componentDidMount() {
    var branch_id = this.props.branch_id;
    this.setState({ branch_id: branch_id });
    this._getBranch(branch_id);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.testUsedate !== this.state.testUsedate) {
      this.setState({ testUsedate: nextProps.testUsedate });
    }

    if (nextProps.experienceType !== this.state.experienceType) {
      this.setState({ experienceType: nextProps.experienceType });
    }

    if (nextProps.studyType !== this.state.studyType) {
      this.setState({ studyType: nextProps.studyType });
    }

    if (nextProps.recogType !== this.state.recogType) {
      this.setState({ recogType: nextProps.recogType });
    }

    if (nextProps.memberType !== this.state.memberType) {
      this.setState({ memberType: nextProps.memberType });
    }
  }

  _initParam(branch_id) {
      this.setState({
        branchName: '',
        branch_id: branch_id,
        memberSex: '',
        testUsedate: '',
        experienceType: '',
        memberName: '',
        memberBirthday: '',
        memberType: '',
        memberPhone: '',
        isWait: false,
        isParentReservation: '',
        studyType: '',
        recogType: '',
        isPolicy: false,
        isPrivacy: false,
        isMarketingAgree: false,
        isVerifyPhone: false,
        isVerifyExpired: false,
        isKioskForCobosys: false,
        verifyNum: '',
        inputVerifyNum: '',
        verifyNumText: '',
        expireSec: 180,
        expireCount: 0,
        expireText: ''
      });

      this._inputMemberName.value = '';
      if(this._inputMemberBirthday) this._inputMemberBirthday.value = '';
      this._inputMemberPhone.value = '';
      this._inputVerifyNum.value = '';

      this._policy.checked = false;
      this._privacy.checked = false;
      this._marketing.checked = false;

      this._getBranch(branch_id);
  }

  _getParams() {
    return {
      branch_id: this.state.branch_id,
      branchName: this.state.branchName,
      memberSex: this.state.memberSex,
      testUsedate: this.state.testUsedate,
      experienceType: this.state.experienceType,
      memberName: this.state.memberName,
      memberBirthday: this.state.memberBirthday,
      memberType: this.state.memberType,
      memberPhone: this.state.memberPhone,
      isWait: false,
      isParentReservation: this.state.isParentReservation,
      studyType: this.state.studyType,
      recogType: this.state.recogType,
      isPolicy: this.state.isPolicy,
      isPrivacy: this.state.isPrivacy,
      isMarketingAgree: this.state.isMarketingAgree,
      isVerifyPhone: this.state.isVerifyPhone
    }
  }

  /**
   * 지점 상세 조회
   * @param {지점 id} branch_id 
   */
  _getBranch(branch_id) {
    Common.callApi('/hp/branch/' + branch_id, 'get', null)
    .then(result => {
      if(result.resultCode === 'success') {
        var resultData = result.resultData;
        this.setState({ 
          branchName: resultData.branchName,
          isKioskForCobosys: resultData.isKioskForCobosys !== 0
        });
      } else {
        Actions.alertOpen({msg: result.resultMessage}, [{type: 'ok', label: '확인'}]);
      }
    });
  }

  /**
   * 성별 선택 event
   */
  _doSelectMemberSexEvent = (memberSex) => {
    this.setState({ memberSex: memberSex });
  }

  /**
   * 학부모 여부 선택 event
   */
  _doSelectParentEvent = (isParentReservation) => {
    this.setState({ isParentReservation: isParentReservation });
  }

  /**
   * 인증번호 발송
   */
  _sendVerifyNum = (e) => {
    var memberPhone = this.state.memberPhone;
    if(!memberPhone) {
      Actions.alertOpen({msg: '휴대번호를 입력해주세요.'}, [{type: 'ok', label: '확인'}]);
      return false;
    }

    if(!Common.isPhoneNumberValidation(memberPhone)) {
      Actions.alertOpen({msg: '휴대번호가 올바르지 않습니다.'}, [{type: 'ok', label: '확인'}]);
      return false;
    }

    Common.callApi('/verifyPhone', 'post', {memberPhone: memberPhone, message: '[토즈 스터디센터] 인증번호 ( ##### )를 입력 해주세요.'})
    .then(result => {
        if(result.resultCode === 'success') {
          this._stopVerifyTime();
          this.setState({ verifyNum: result.resultData.verifyNum });

          _timer = setInterval(() => {
            var _expireSec = this.state.expireCount - 1;
            if(_expireSec < 0) {
              this._stopVerifyTime();
              this.setState({
                expireText: '인증번호가 만료되었습니다.',
                isVerifyExpired: true
              });
              return;
            }
            this.setState({
              expireText: '만료시간 ' + Common.secToMin(_expireSec),
              expireCount: _expireSec
            });
          }, 1000);

          this.setState({verifyNum: result.resultData.verifyNum });

          Actions.alertOpen({msg: '인증번호가 발송되었습니다.'}, [{type: 'ok', label: '확인'}]);
        } else {
          Actions.alertOpen({msg: result.resultMessage}, [{type: 'ok', label: '확인'}]);
        }
      }
    );
  }

  /**
   * 인증번호 입력 시간 타이머 stop
   */
  _stopVerifyTime = () => {
    clearInterval(_timer);
    this.setState({
      expireCount: 180,
      expireText: '',
      verifyNum: '',
      inputVerifyNum: '',
      isVerifyPhone: false,
      isVerifyExpired: false
    });
    _timer = null;
  }

  /**
   * 인증번호 check
   */
  _checkVerifyNum = () => {
    var inputVerifyNum = this.state.inputVerifyNum;
    if(inputVerifyNum === '') {
      Actions.alertOpen({msg: '인증번호를 입력해주세요.'}, [{type: 'ok', label: '확인'}]);
      return false;
    }

    if(this.state.isVerifyExpired) {
      Actions.alertOpen({msg: '인증번호가 만료되었습니다.<br/>휴대번호 인증을 다시 진행해주세요.'}, [{type: 'ok', label: '확인'}]);
      return false;
    }

    if(this.state.verifyNum !== inputVerifyNum) {
      Actions.alertOpen({msg: '인증번호가 올바르지 않습니다.'}, [{type: 'ok', label: '확인'}]);
      return false;
    } else {
      Actions.alertOpen({msg: '휴대번호 인증이 완료되었습니다.'}, [{type: 'ok', label: '확인'}]);
      this._stopVerifyTime();
      this.setState({ isVerifyPhone: true });
    }
  }

  /**
   * 신청정보 form rendering
   */
  _renderForm() {
    if(this.props.type === 'request') {
      // 무료체험 신청 form
      return (
        <div className="app-info">
          <p className="title">신청 정보</p>
          <ul className="list">
            <li className="loca">
              <p className="btxt">체험 센터</p>
              <p className="stxt fl">{this.state.branchName}</p>
              <a href={null} className="loca-btn fr layer-pop-open" data-type="location" data-branch_id={this.state.branch_id} onClick={this.props.onClick}>위치보기</a>
            </li>
            <li className="gender-sel">
              <p className="btxt">이용자 성별</p>
              <a href={null} className={this.state.memberSex === '남' ? "sel-btn fl active" : "sel-btn fl"} onClick={this._doSelectMemberSexEvent.bind(this, '남')}>남</a>
              <a href={null} className={this.state.memberSex === '여' ? "sel-btn fr active" : "sel-btn fr"} onClick={this._doSelectMemberSexEvent.bind(this, '여')}>여</a>
            </li>
            <li>
              <p className="btxt">체험 일자</p>
              <p className="pop-sel layer-pop-open" data-type="calendar" data-branch_id={this.state.branch_id} onClick={this.props.onClick}>{this.state.testUsedate === '' ? '체험 일자 선택' : this.state.testUsedate}</p>
            </li>
            <li>
              <p className="btxt">체험 시간</p>
              <p className="pop-sel layer-pop-open" data-type="experienceType" onClick={this.props.onClick}>{this.state.experienceType === '' ? '체험 시간 선택' : experienceTypeMap[this.state.experienceType]}</p>
            </li>
            <li>
              <p className="btxt">이름</p>
              <input type="text" placeholder="이름 입력" ref={ref => this._inputMemberName = ref} onKeyUp={e => this.setState({ memberName: e.target.value })} />
            </li>
            <li>
              <p className="btxt">생년 월일</p>
              <input type="tel" className="fl" placeholder="생년 월일(8자리) 입력" maxLength="8" ref={ref => this._inputMemberBirthday = ref} onKeyUp={e => this.setState({ memberBirthday: e.target.value })} />
            </li>
            <li>
              <p className="btxt">휴대번호</p>
              <p className="certi-input">
                <input type="tel" className="fl" placeholder="휴대번호 입력" maxLength="11" ref={ref => this._inputMemberPhone = ref} onKeyUp={e => this.setState({ memberPhone: e.target.value })} />
                <a href={null} className="certi-btn fr" onClick={this._sendVerifyNum}>인증번호 발송</a>
              </p>
              <p className="certi-input">
                <input type="tel" className="fl" placeholder="인증번호 입력" maxLength="6" ref={ref => this._inputVerifyNum = ref} onKeyUp={e => this.setState({ inputVerifyNum: e.target.value })} />
                <a href={null} className="certi-btn fr" onClick={this._checkVerifyNum}>인증 완료</a>
              </p>
              <p className="certi-time">{this.state.expireText ? this.state.expireText : ''}</p>
            </li>
            <li>
              <p className="btxt">공부 목표</p>
              <p className="pop-sel layer-pop-open" data-type="studyType" onClick={this.props.onClick}>{this.state.studyType === '' ? '공부 목표 선택' : this.state.studyType}</p>
            </li>
            <li>
              <p className="btxt">인지 경로</p>
              <p className="pop-sel layer-pop-open" data-type="recogType" onClick={this.props.onClick}>{this.state.recogType === '' ? '인지 경로 선택': this.state.recogType}</p>
            </li>
            <li className="parent-sel">
              <p className="btxt">학부모 이신가요?</p>
              <a href={null} className={this.state.isParentReservation === 'true' ? 'sel-btn fl active' : 'sel-btn fl'} onClick={this._doSelectParentEvent.bind(this, 'true')}>네</a>
              <a href={null} className={this.state.isParentReservation === 'false' ? 'sel-btn fr active' : 'sel-btn fr'} onClick={this._doSelectParentEvent.bind(this, 'false')}>아니요</a>
            </li>
          </ul>
        </div>
      )
    } else if(this.props.type === 'inquiry') {
      // 전화상담신청 form
      return (
        <div className="app-info">
          <p className="title">신청 정보</p>
          <ul className="list">
            <li className="loca">
              <p className="btxt">체험 센터</p>
              <p className="stxt fl">{this.state.branchName}</p>
              <a href={null} className="loca-btn fr layer-pop-open" data-type="location" data-branch_id={this.state.branch_id} onClick={this.props.onClick}>위치보기</a>
            </li>
            <li>
              <p className="btxt">이름</p>
              <input type="text" placeholder="이름 입력" ref={ref => this._inputMemberName = ref} onKeyUp={e => this.setState({ memberName: e.target.value })} />
            </li>
            <li>
              <p className="btxt">고객 유형</p>
              <p className="pop-sel layer-pop-open" data-type="memberType" onClick={this.props.onClick}>{this.state.memberType === '' ? '고객 유형 선택' : this.state.memberType}</p>
            </li>
            <li>
              <p className="btxt">휴대번호</p>
              <p className="certi-input">
                <input type="tel" className="fl" placeholder="휴대번호 입력" maxLength="11" ref={ref => this._inputMemberPhone = ref} onKeyUp={e => this.setState({ memberPhone: e.target.value })} />
                <a href={null} className="certi-btn fr" onClick={this._sendVerifyNum}>인증번호 발송</a>
              </p>
              <p className="certi-input">
                <input type="tel" className="fl" placeholder="인증번호 입력" maxLength="6" ref={ref => this._inputVerifyNum = ref} onKeyUp={e => this.setState({ inputVerifyNum: e.target.value })} />
                <a href={null} className="certi-btn fr" onClick={this._checkVerifyNum}>인증 완료</a>
              </p>
              <p className="certi-time">{this.state.expireText ? this.state.expireText : ''}</p>
            </li>
          </ul>
        </div>
      )
    }
  }

  _renderNotice() {
    // 하단 유의사항 박스 rendering
    if(this.props.type === 'request') {
      // 무료체험 신청
      return (
        <div className="note-text">
          <p className="tit">※유의 사항</p>
          <ul className="list">
            <li>2019년 4월부터 토즈 스터디센터에서는 본인인증을 시행하고 있습니다. 실 체험 시 본인 명의로 인증을 받아야 체험이 가능합니다. (반드시 본인명의의 휴대폰으로 신청해주세요.)</li>
            <li>신청 완료 시 카카오 알림톡 또는 SMS가 발송됩니다.</li>
            <li>중학교 3학년 이하의 학생은 독서실 면학분위기 조성으로 인하여 무료체험 이용이 어렵습니다.</li>
            <li>센터 상황에 따라 무료체험을 진행하지 않을 수 있습니다.</li>
            <li>당일 센터 상황에 따라 소셜룸, 자유석, 고정석 등 좌석이 제공되는점 양해 부탁드립니다. 공부에 집중하실 수 있게 최선을 다하겠습니다. 감사합니다.</li>
            { !this.state.isKioskForCobosys ? "" :
              <Fragment>
                <li>선택하신 지점의 경우 키오스크 설치 지점으로 무료체험 신청 후 지점에 방문하여 키오스크를 이용하시면 체험이 가능합니다.</li>
                <li>키오스크 사용절차 (가입 &gt; 로그인 &gt; 좌석선택 &gt; 무료체험 상품선택 &gt; 입실) </li>
              </Fragment>
            }
          </ul>
        </div>
      )
    } else if(this.props.type === 'inquiry') {
      // 전화상담 신청
      return (<div></div>)
    }
  }

  render() {
    return (
      <div>
        {this._renderForm()}

        {this._renderNotice()}

        <ul className="agree-checks">
          <li>
            <p className="checks fl">
              <input id="ex_cb1" type="checkbox" ref={ref => this._policy = ref} onChange={e => this.setState({ isPolicy: !this.state.isPolicy })} />
              <label htmlFor="ex_cb1">이용약관 동의(필수)</label> 
            </p>
            <a href="/rule/policy/tsc" target="_blank" rel="noopener noreferrer" className="txt-view fr" data-type="policy">[내용보기]</a>
          </li>
          <li>
            <p className="checks fl">
              <input id="ex_cb2" type="checkbox" ref={ref => this._privacy = ref} onChange={e => this.setState({ isPrivacy: !this.state.isPrivacy })} />
              <label htmlFor="ex_cb2">개인정보 처리방침 동의(필수)</label> 
            </p>
            <a href="/rule/privacy" target="_blank" rel="noopener noreferrer" className="txt-view fr" data-type="privacy">[내용보기]</a>
          </li>
          <li>
            <p className="checks fl">
              <input id="ex_cb3" type="checkbox" ref={ref => this._marketing = ref} onChange={e => this.setState({ isMarketingAgree: !this.state.isMarketingAgree })} />
              <label htmlFor="ex_cb3">마케팅 수신 동의(선택)</label> 
            </p>
            <a href="/rule/privacy" target="_blank" rel="noopener noreferrer" className="txt-view fr" data-type="marketing">[내용보기]</a>
          </li>
        </ul>

        <div className="appinfo-fbtn">
          <a href={null} className="b-btn layer-pop-open" onClick={Actions.doCheckValidation}>{this.props.type === 'request' ? '공부 신청 완료' : '신청 접수 완료'}</a>
        </div>
      </div>
    )
  }
}

export default RequestForm;